"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _logging = _interopRequireDefault(require("logging"));
var _events = _interopRequireDefault(require("events"));
var _browserOrNode = require("browser-or-node");
var _detectBrowser = require("detect-browser");
var _index = require("./constants/index");
var _config = require("./config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-undef */
const logger = (0, _logging.default)('MewConnectCommon');
class MewConnectCommon extends _events.default {
  constructor() {
    let version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    super();
    this.isBrowser = _browserOrNode.isBrowser;
    this.jsonDetails = {
      stunSrvers: [..._config.stunServers],
      signalServer: (0, _index.signalServer)(version),
      signals: _objectSpread({}, (0, _index.signal)(version)),
      signalsV1: _objectSpread({}, _index.signals.V1),
      signalsV2: _objectSpread({}, _index.signals.V2),
      stages: _objectSpread({}, _index.stages),
      lifeCycle: _objectSpread({}, _index.lifeCycle),
      rtc: _objectSpread({}, _index.rtc),
      communicationTypes: _objectSpread({}, _index.communicationTypes),
      iceConnectionState: _objectSpread({}, _index.iceConnectionState),
      connectionCodeSeparator: _index.connectionCodeSeparator,
      version,
      versions: _index.versions,
      connectionCodeSchemas: _index.connectionCodeSchemas
    };
  }
  isJSON(arg) {
    try {
      JSON.parse(arg);
      return true;
    } catch (e) {
      return false;
    }
  }
  static getBrowserRTC() {
    if (typeof window === 'undefined') return null;
    const wrtc = {
      RTCPeerConnection:
      // eslint-disable-next-line no-undef
      window.RTCPeerConnection ||
      // eslint-disable-next-line no-undef
      window.mozRTCPeerConnection ||
      // eslint-disable-next-line no-undef
      window.webkitRTCPeerConnection,
      RTCSessionDescription:
      // eslint-disable-next-line no-undef
      window.RTCSessionDescription ||
      // eslint-disable-next-line no-undef
      window.mozRTCSessionDescription ||
      // eslint-disable-next-line no-undef
      window.webkitRTCSessionDescription,
      RTCIceCandidate:
      // eslint-disable-next-line no-undef
      window.RTCIceCandidate ||
      // eslint-disable-next-line no-undef
      window.mozRTCIceCandidate ||
      // eslint-disable-next-line no-undef
      window.webkitRTCIceCandidate
    };
    if (!wrtc.RTCPeerConnection) return null;
    return wrtc;
  }
  static checkWebRTCAvailable() {
    const doesNotHaveWebRTC = MewConnectCommon.getBrowserRTC() == null;
    return !doesNotHaveWebRTC;
    // return false
  }
  static checkBrowser() {
    let browser = (0, _detectBrowser.detect)();
    if (browser === null) {
      browser = {
        version: {
          split: () => [1]
        }
      };
    }
    const browserVersion = browser.version.split(0, 1)[0];
    /*
     * Chrome > 23
     * Firefox > 22
     * Opera > 18
     * Safari > 11 (caveats exist)
     * Edge - none (RTCDataChannel not supported)
     * IE - none
     * */
    if (typeof window !== 'undefined') {
      if (browser.name === 'safari') {
        // eslint-disable-next-line global-require
        require('webrtc-adapter');
        return MewConnectCommon.buildBrowserResult(true, 'Safari', `version: ${browser.version}`);
      }
      if (browser.name === 'ie') {
        return MewConnectCommon.buildBrowserResult(true, 'Internet Explorer', '', true);
      }
      if (browser.name === 'edge') {
        return MewConnectCommon.buildBrowserResult(true, 'Edge', `version: ${browser.version}`, true);
      }
      let name = '';
      let minVersion = 0;
      if (browser.name === 'opera') {
        name = 'Opera';
        minVersion = 18;
      } else if (browser.name === 'firefox') {
        name = 'Firefox';
        minVersion = 22;
      } else if (browser.name === 'chrome') {
        name = 'Chrome';
        minVersion = 23;
      } else {
        return MewConnectCommon.buildBrowserResult(false, '', '', true);
      }
      try {
        if (minVersion >= +browserVersion) {
          return MewConnectCommon.buildBrowserResult(true, name, `version: ${browserVersion}`);
        }
        return MewConnectCommon.buildBrowserResult(false, '', '');
      } catch (e) {
        logger.error(e);
      }
    }
  }
  static buildBrowserResult(status, browser, browserVersion, noSupport) {
    return {
      status,
      browser,
      browserVersion,
      noSupport: noSupport || false
    };
  }
}
exports.default = MewConnectCommon;